import { render, staticRenderFns } from "./ImportManifests.vue?vue&type=template&id=05ced28b&scoped=true"
import script from "./ImportManifests.vue?vue&type=script&lang=ts"
export * from "./ImportManifests.vue?vue&type=script&lang=ts"
import style0 from "./ImportManifests.vue?vue&type=style&index=0&id=05ced28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ced28b",
  null
  
)

export default component.exports